/**
 * Wes header glyph — simplified illustrated mark for the top bar.
 */

import { WES_AVATAR_IMAGE_STYLE } from './wesAvatarFrame';

export function WesHeaderIcon({ className = 'h-4 w-4 shrink-0 rounded-full object-cover' }: { className?: string }) {
  return (
    <img
      src="/assets/wes-avatar.png"
      alt=""
      aria-hidden
      className={className}
      style={WES_AVATAR_IMAGE_STYLE}
      draggable={false}
    />
  );
}
